export default __webpack_public_path__ + "static/media/apiconnect.b64630cb.svg";